import { UseDocument } from './types'

export const emptyUseDocument: UseDocument<any> = {
  data: null,
  loading: false,
  error: 'UseDocument not initialized',
  refetch: () => {},
  onSave: async () => false,
  onDelete: async () => false,
  ref: null,
  set: async () => {},
  update: async () => {},
}
